import { render, staticRenderFns } from "./RegularBuyBoxNew.vue?vue&type=template&id=924fbdac&scoped=true"
import script from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularBuyBoxNew.vue?vue&type=style&index=0&id=924fbdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924fbdac",
  null
  
)

export default component.exports